module.exports = __webpack_public_path__ + "img/调查问卷.6a31293c.png";